import { Component } from '@angular/core';

@Component({
  selector: 'gung-table-skeleton-loader',
  templateUrl: './gung-table-skeleton-loader.component.html',
  styleUrls: ['./gung-table-skeleton-loader.component.scss'],
  standalone: false
})
export class GungTableSkeletonLoaderComponent {
  rowArray = Array.from({ length: 15 }, (_, i) => i);
  columnArray = [0, 1, 2, 3];
}
